var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1538 6.99998C7.81065 6.99998 9.15379 5.65684 9.15379 3.99999C9.15379 2.34314 7.81065 1 6.1538 1C4.49695 1 3.15381 2.34314 3.15381 3.99999C3.15381 5.65684 4.49695 6.99998 6.1538 6.99998Z",
    stroke: "#6D7279",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.308 13C11.308 10.678 8.99799 8.80005 6.154 8.80005C3.31001 8.80005 1 10.678 1 13",
    stroke: "#6D7279",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.8f5a2b5ee86d8cb0b1faaff717584932.svg";
export { ForwardRef as ReactComponent };